import { useTranslation } from 'react-i18next';

export enum Currency {
  UZS = 'UZS',
  KZT = 'KZT',
}

export default function useMoneyFormatter() {
  const [t] = useTranslation('currency');
  return (
    money?: number,
    currency?: Currency | null,
    disableRound?: boolean,
  ) => {
    let currencyLabel = '';
    if (currency === null) {
      currencyLabel = ` ${t('UZS')}`;
    }
    if (currency?.length) {
      currencyLabel = ` ${t(`${currency}`)}`;
    }
    if (!money) return `${0}${currencyLabel}`;
    if (disableRound) {
      return (money / 100).toFixed(2).replace(/(\d)(?=((\d{3})+)(\D|$))/g, '$& ') + currencyLabel;
    }
    return Math.round(money / 100).toString().replace(/(\d)(?=((\d{3})+)(\D|$))/g, '$& ') + currencyLabel;
  };
}
